import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { ItemAliasFormState } from '../../../_state/itemAliasForm.state';
import { ItemAliasRecord } from '../../../types/inventoryItem';

import { ItemAliasDetailsForm } from './ItemAliasDetailsForm';
import { ItemAliasFormFooterActions } from './ItemAliasFormFooterActions';

type Props = {
  itemAlias?: ItemAliasRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: ItemAliasFormState) => void;
  isSaving?: boolean;
};

export const ItemAliasTabDetails: React.FC<Props> = ({
  itemAlias,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@ItemAliasTabDetails flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <ItemAliasDetailsForm itemAlias={itemAlias} disabled={false} />
      <ItemAliasFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
